import React from 'react';
import style from './_productBrief.scss';
import {Link} from 'react-router-dom';
import {UploadImage} from 'components/UI/Image';
import PropTypes from 'prop-types';
import {ShowIf} from 'components/utils';
import {getPrice} from 'lib/convert';

class ProductBrief extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    if (!this.props.product) {
      return null;
    }
    const { name, price, promotionalPrice, images } = this.props.product;
    const defaultImage = images && images.length ? images[images.length - 1] : '';
    return (
      <div className='shopping-cart-container'>
        <div className='shopping-cart-left-content'>
          <div className='table-list-item-shopping'>
            <div className="table-list-item-body">
              <div className="item-shoppingg">
                <div className='item-shopping-img-wrap'>
                  <UploadImage type="PRODUCT" width="128" height="128" transform="crop" image={defaultImage} />
                </div>
                <p className='item-shopping-name'>{name}</p>
                <div className='item-shopping-price-wrap'>
                  <p className='item-price'>{getPrice(promotionalPrice || price)}</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductBrief;



// WEBPACK FOOTER //
// ./components/partials/product/ProductBrief.jsx